import { useContext } from "react";
import Api from "../api/services/Api";
import ConfirmationDialogContext from "../components/Dialog/ConfirmationDialog/ConfirmationDialogContext";

export enum LogLevel {
  ERROR,
  WARN,
  INFO,
  DEBUG,
}

export interface Environment {
  api: Api;
  environment: string;
  oidc: { authority: string; clientId: string };
  log: (level: LogLevel, message: string, ...args: unknown[]) => void;
}

export default function useEnv(): Environment {
  const envObject = JSON.parse(localStorage.getItem("envObject") || "{}");
  const environment = envObject.environment || "unknown";
  const clientId = envObject.oidc_clientId || "unknown";
  const authority = envObject.oidc_authority || "unknown";
  const dialogContext = useContext(ConfirmationDialogContext);
  const api = new Api(dialogContext);
  const log = (level: LogLevel, message: string, ...args: unknown[]) => {
    if (level === LogLevel.DEBUG && ["minikube"].includes(environment)) {
      console.debug(message, ...args);
    } else if (level === LogLevel.INFO && ["minikube", "test", "staging"].includes(environment)) {
      console.log(message, ...args);
    } else if (level === LogLevel.WARN) {
      console.warn(message, ...args);
    } else if (level === LogLevel.ERROR) {
      console.error(message, ...args);
    }
  };
  return { api, environment, log, oidc: { authority, clientId } };
}
